import React, { useState, useContext, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TableCell } from '@material-ui/core';
import _ from 'lodash';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import SportsBettingContext from '../../Context/SportsBetting.context';
import LayoutType0 from '../LayoutTypes/LayoutType0';
import LayoutType1 from '../LayoutTypes/LayoutType1';
import LayoutType2 from '../LayoutTypes/LayoutType2';
import LayoutType3 from '../LayoutTypes/LayoutType3';
import LayoutType4 from '../LayoutTypes/LayoutType4';
import LayoutType5 from '../LayoutTypes/LayoutType5';
import MatchTracker from 'src/components/MatchTracker/MatchTracker';
import DraggableDialog from 'src/components/DraggableDialog/DraggableDialog';
import useIsMobile from 'src/hooks/useIsMobile';
import AppModeContext from 'src/containers/AppMode/AppMode.context';
import Icon from 'src/components/Icon/Icon';

const COMPONENTS = {
  LayoutType0,
  LayoutType1,
  LayoutType2,
  LayoutType3,
  LayoutType4,
  LayoutType5
};

function MarketsGrid({ event, removeFromBetslip, addToBetslip, displayMarkets, visibleTracker }) {
  const { selectedEvent, showMobileTracker, liveOutcomes, shouldReloadTabs } = useSelector(state => state.events);
  const customerId = useSelector((state) => state.auth.customerId);

  const [selectedTag, setSelectedTag] = useState('');
  const [showDialog, setShowDialog] = useState(false);

  const marketGridHeight = useRef(null);

  const { RETAIL_MODE } = useContext(AppModeContext);
  const dispatch = useDispatch();
  const isRetail = RETAIL_MODE;

  const { maxMainMarkets } = useContext(SportsBettingContext);
  const popupRef = useRef(null);
  const mobile = useIsMobile();

  const tag = _.find(selectedEvent.markets, m => m.id === selectedTag);

  useEffect(() => {
    if (selectedEvent.markets && shouldReloadTabs){
      const firstTag = selectedEvent?.markets[0];

      if (firstTag?.id) {
        setSelectedTag(firstTag.id);
      }
      dispatch.events.changeShouldReloadTabs(false);
    }

    return () => {
      dispatch.events.changeShouldReloadTabs(true);
    };
  }, [selectedEvent]);

  const goTop = () => {
    marketGridHeight.current.scrollIntoView(
      {
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
  };

  useEffect(() => {
    if (marketGridHeight.current){
      goTop();
    }
  }, [marketGridHeight.current]);

  const selectTag = (value) => (e) => {
    e.preventDefault();

    setSelectedTag(value);
    goTop();
  };

  useEffect(() => {
    const tillId = localStorage.getItem('tillId') ? localStorage.getItem('tillId') : -1;

    const response = new EventSource(`${ process.env.REACT_APP_BASE_URL
    }/bets/check-outcomes/${ liveOutcomes.join(',') }?tillId=${ tillId }&customerId=${ customerId ? customerId : -1 }`);
    response.onmessage = (e) => dispatch.events.updateAllMarkets(e.data);

    if (_.isEmpty(selectedEvent)){
      dispatch.events.changeShouldReloadTabs(true);
      response.close();
    }

    return () => {
      response.close();
    };

  }, [liveOutcomes, selectedEvent]);

  return (
    <TableCell
      className="event-row__event-markets-container"
      style={ { paddingBottom: 0, paddingTop: 0 } }
      colSpan={ 8 + (maxMainMarkets * 6) }
    >
      <div ref={ popupRef }></div>
      {
        ((visibleTracker || (mobile && showMobileTracker)) && !showDialog) &&  (
          <div className="event-row__track-container">
            { !mobile && <div className="event-row__filler" /> }
            <div className="event-row__container">
              <MatchTracker id={ event.linkId } />
            </div>
            { !mobile && <div className="event-row__filler" /> }
          </div>

        )
      }
      {
        showDialog && mobile && displayMarkets && (
          <DraggableDialog className="event-row__dialog" anchorEl={ popupRef.current } canResize>
            <DraggableDialog.Title onClose={ () => setShowDialog(false) }>{ event.name }</DraggableDialog.Title>
            <DraggableDialog.Content>
              <MatchTracker id={ event.linkId } />
            </DraggableDialog.Content>
          </DraggableDialog>
        )
      }
      <div
        className="event-row__markets-tags-container"
        ref={ event.eventCode.toString() === selectedEvent.code && selectedTag !== '' ? marketGridHeight : null }
      >
        {
          event.eventCode.toString() === selectedEvent.code &&
        selectedEvent.markets && !_.isEmpty(selectedEvent.markets) && displayMarkets && (
            <div className={
              classNames({
                'event-row__event-tags': true,
                'event-row__event-tags--retail': isRetail
              })
            }
            >
              {
                _.map(selectedEvent.markets, (m, mi) => {
                  return (
                    <button
                      key={ mi }
                      className={
                        classNames({
                          'event-row__event-market-option': true,
                          'event-row__event-market-option--selected': m.id === selectedTag
                        })
                      }
                      onClick={ selectTag(m.id) }
                    >
                      { m.name }
                    </button>
                  );
                })
              }
            </div>
          )
        }

        {
          displayMarkets &&

      <div
        className={
          classNames({
            'event-table__grid': true,
            'event-table__grid--retail': isRetail
          })
        }
      >
        {
          event.eventCode.toString() === selectedEvent.code && selectedTag !== '' &&
          tag && _.map(tag.markets, (market, index) => {
            const layoutType = market.layoutType !== null ? market.layoutType : 1;
            const MarketsLayout = COMPONENTS[`LayoutType${ layoutType }`];

            return <MarketsLayout
              key={ market.name + index }
              removeFromBetslip={ removeFromBetslip }
              addToBetslip={ addToBetslip }
              market={ market }
              mobile={ mobile }
              isSuspended={ event.statusNumber === 7 }
            />;
          })
        }
        {
          marketGridHeight.current &&
                        <div
                          className={
                            classNames({
                              'go-up-button': true,
                              'go-up-button--hide': false,
                              'go-up-button--sticky': true,
                              'go-up-button--all-markets': true
                            })
                          }
                          onClick={ goTop }
                        >
                          <Icon icon="GoUpArrow" className="go-up-button__arrow" onClick={ goTop } />
                        </div>
        }
      </div>
        }
      </div>
    </TableCell>
  );
}

MarketsGrid.propTypes = {
  event: PropTypes.object,
  removeFromBetslip: PropTypes.func,
  addToBetslip: PropTypes.func,
  displayMarkets: PropTypes.bool,
  visibleTracker: PropTypes.bool
};

export default MarketsGrid;
